module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/content/section'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Konten")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/article'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Artikel")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/video'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Video Gratis")])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, _vm._l((_vm.items), function(menu, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          path: '/content/itembank?mapel=' + menu.id
        },
        "tag": "li"
      }
    }, [_c('a', [_vm._v(_vm._s(menu.nama))])])
  }), 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/banner'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Banner")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/menu'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Menu")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/preview'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan & Preview")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/config'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan Aplikasi ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/ads-setting'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan Iklan ")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Konfigurasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', [_vm._v("Soal Gratis")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0493ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/Navigation.vue
// module id = 1293
// module chunks = 0